//para el build de mazorca
import '../sass/mazorca.scss'